import { render, staticRenderFns } from "./Members.vue?vue&type=template&id=28c3bc4e&scoped=true&"
import script from "./Members.vue?vue&type=script&lang=js&"
export * from "./Members.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c3bc4e",
  null
  
)

export default component.exports